import { ICountry } from "@myinnsworth/models/address/ICountry";
import HttpServiceBase from "../httpServiceBase";
import { ISearchResults } from "@myinnsworth/models/ISearchResults";

class ListHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'list' };
    
    public async fetchCountries(): Promise<Array<ICountry>> {
        let result = Array<ICountry>();
        try {
            const response = await this.typedGet<ISearchResults<ICountry>>(`countries`);
            result = response.results;
        } catch(ex) {
            return Promise.reject(ex);
        }
        return result;
    }
}

const service = new ListHttpService();
export default service;